import get from 'immutable-less/transmute/get';
import getIn from 'immutable-less/transmute/getIn';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Code from 'UIComponents/elements/Code';
import { getServiceTokenPrefix } from 'automation-ui-action-features/personalized-text/personalizedTextUtils';
import PersonalizedTextView from 'automation-ui-action-features/personalized-text/PersonalizedTextView';
import DataSourcePropertyName from 'automation-ui-formula-editor/data-sources/DataSourcePropertyName';
import DataSourceName from 'automation-ui-formula-editor/data-sources/DataSourceName';
import { jsx as _jsx } from "react/jsx-runtime";
function DataSourceDescription({
  getHeaderTitle,
  objectTypeId,
  variable,
  variableContext,
  actionOutputsForTargetActionById
}) {
  const sourceActionId = getIn(['identifier', 'actionId'], variableContext);
  const sourceDataKey = getIn(['identifier', 'dataKey'], variableContext);
  const propertyName = get('propertyName', variableContext);
  const propertyToken = get('propertyToken', variableContext);
  if (!variable) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.formula.data-source-description.no-data-source"
    });
  }
  if (propertyToken) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.formula.data-source-description.property-token",
      options: {
        dataSource: /*#__PURE__*/_jsx(DataSourceName, {
          token: propertyToken
        }),
        dataProperty: /*#__PURE__*/_jsx(DataSourcePropertyName, {
          token: propertyToken
        })
      }
    });
  }
  const actionOutputs = actionOutputsForTargetActionById.find(({
    actionId
  }) => actionId === sourceActionId);
  const actionOutput = actionOutputs && actionOutputs.outputFieldDefinitions.find(({
    typeDefinition: {
      name
    }
  }) => name === sourceDataKey);
  const actionOutputLabel = getIn(['typeDefinition', 'label'], actionOutput);
  return variable.isPersonalizationToken || propertyName ? /*#__PURE__*/_jsx(PersonalizedTextView, {
    propertyTypeId: objectTypeId,
    text: `{{ ${getServiceTokenPrefix(objectTypeId)}.${variable.name} }}`
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.formula.data-source-description.action-output",
    options: {
      dataSource: actionOutputLabel || /*#__PURE__*/_jsx(Code, {
        children: sourceDataKey
      }),
      action: getHeaderTitle({
        actionId: sourceActionId || undefined
      })
    }
  });
}
export default DataSourceDescription;